import React from 'react'
import { replaceYear } from '../../../../common/utils'
import PageHelmet from '../../components/PageHelmet/PageHelmet'
import replaceText from '../../../../common/utils/replaceText'

const ArticlePageHelmet = ({ article, canonicalUrl, quizItem, tokens }) => {
  return (
    <PageHelmet
      {...{
        id: 507826,
        questions: quizItem?.test && quizItem?.test?.questions,
        title: replaceText(tokens, article.metaTitle || article.title),
        description:
          article.metaDescription && replaceText(tokens, article.metaDescription),
        image: article.coverImage?.ogImage || article.insetImage?.ogImage,
        url: canonicalUrl,
        lang: article.language,
        disableAds: article.disableAds,
        article: {
          updatedDate: article.meta?.updatedAt,
          createdDate: article.meta?.createdAt,
          subcategory: article.category?.category?.title,
          author: article.author?.name,
          publishedAt: article.meta?.publishedAt,
          firstPublishedAt: article.meta?.firstPublishedAt,
        },
        alternateUrl: article.languageAlternativesHreflang,
      }}
    />
  )
}

export default ArticlePageHelmet
